<template>
  <RadioButton
    @input="$emit('input', value)"
    :value="value"
    :option="option"
    :checked="isESignatureSelected"
    class="rd-card mt-10 heading-4 weight-medium"
    title='Digital Signature'
    with-badge>
    <template v-slot:info>
      <p class="body-3 mt-5">
        You can sign the application form on your smartphone or tablet using your finger or a stylus.
      </p>
    </template>
    <template v-slot:default>
      <div>
        <InfoBox class="mt-5 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
          <p class="m-0 pr-md-5 weight-regular body-3">
            
    <b>You will need:</b>
    <ul class="p-0">
        <li>
        Smartphone, tablet, or some other touch screen with supported browsers: Google Chrome or Safari
        </li>
        <li>
        Proof of identity as stated on the application form and issued in the Slovak Republic
        </li>
    </ul>
    <b>Please note:</b>
    <br/>
    <b>
    If you have a proof of identity issued abroad, you cannot use a digital signature to sign your application. Please choose another method of signing the application.
    </b>
    <br/>
    <br/>
    Before signing the application, please ensure you have the latest version of Google Chrome installed on your smartphone or tablet.
    <br/>
    <br/>
    <b>How does it work?</b>
    <br/>
    <br/>
    <b>Submitting the application form on a computer:</b>
    <br/>
    <ul>
        <li>
            Enter your phone number.
        </li>
        <li>
            Open the link we will send you via SMS on your mobile phone.
        </li>
        <li>
            Follow the instructions for completing the application form on your smartphone or tablet.
        </li>
        <li>
            We will send you a PDF of the signed application form by e-mail.
        </li>
    </ul>
    <br/>
    <b>Submitting the application form on your smartphone or tablet:</b>
    <br/>
    <ul>
        <li>
            Provide your consent to the processing of your personal data.
        </li>
        <li>
            Allow access to the camera on your device.
        </li>
        <li>
            On a high contrast, clear background, take a photograph of both sides of the ID card or another proof of identity, as provided in your application.
        </li>
        <li>
            Follow the instructions for completing the application form on your smartphone or tablet.
        </li>
        <li>
            We will send you a PDF of the signed application form by e-mail.
        </li>
    </ul>
  
          </p>
        </InfoBox>
        <div v-if="isESignatureSelected && isVIP" class="mt-5">
          <div v-if="model.isMobile">
            <strong class="block mb-5">Option Selection</strong>
            <div class="input-box-holder" v-validate="errors" v-has-value="delivery.eSignatureDevice">
              <div class="validation-output">
                <ErrorHandler class="error" id="V333">
                  You have not selected any of the options. To continue, please select one option.
                </ErrorHandler>
              </div>

                <RadioButton
                  v-for="(option) in enumsValues.DeviceEnum"
                  class="mb-5"
                  :key="option.name$"
                  :option="option"
                  :title="option.label"
                  :name="'eSignatureDeviceGroup'"
                  :value="delivery.eSignatureDevice"
                  @input="setSignatureDevice">
                </RadioButton>
            </div>
          </div>
        </div>
      </div>
    </template>
  </RadioButton>
</template>
<script>
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import enums from '@/mixins/enums';
import distributionChannels from '@/mixins/distributionChannels';
import persons from '@/mixins/persons';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  components: { InfoBox, RadioButton, ErrorHandler },
  mixins: [enums, distributionChannels, persons],
  props: {
    value: { type: Object, required: false },
    option: { type: Object, required: true },
    delivery: { type: Object, required: true },
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
  },
  methods: {
    setSignatureDevice(value) {
      this.delivery.eSignatureDevice = value;
    },
  },
  computed: {
    DeliveryTypeEnum() { return this.enums.DeliveryTypeEnum; },
    isESignatureSelected() { return this.delivery.deliveryType === this.enums.DeliveryTypeEnum.E_SIGNATURE; },
    showMissingStatementDeviceError() { return this.errors.filter((error) => error === 'V333').length > 0; },
  },
  created() {
    if (!this.model.isMobile) {
      this.delivery.eSignatureDevice = this.enums.DeviceEnum.ON_ANOTHER_DEVICE;
    }
  },
};
</script>
